import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { z } from 'zod'

import Table from '@nxt-insurance/ui-kit/components/Table'
import type { TableData } from '@nxt-insurance/ui-kit/components/Table/types'

import { runQuery } from '@/cms/client'
import { tableQuery } from '@/cms/table'
import { reportErrorMessage } from '@/services/errorReporting'
import { getLocaleParts } from '@/utils/locale'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import { useQuery } from '@tanstack/react-query'

const tableSchema = z.object({
  _key: z.string(),
  _type: z.literal('tableRenderer'),
  table: z.object({
    _type: z.literal('reference'),
    _ref: z.string(),
  }),
})

export const TableRenderer = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = tableSchema.parse(props.node.value)
  const { locale } = useRouter()
  const [lang] = getLocaleParts(locale)
  const { data: table } = useQuery({
    queryKey: ['table', value.table._ref],
    queryFn: async () =>
      runQuery(tableQuery, {
        lang,
        id: value.table._ref,
      }) as Promise<TableData>,
  })

  useEffect(() => {
    reportErrorMessage('Assertion: TableRenderer not fully implemented yet')
  }, [])
  if (!table) {
    return null
  }
  return (
    <div className="w-full">
      <Table data={table} />
    </div>
  )
}
